export default {
	title: "Tipos de Ritual",
	activate: "Activar",
	create: "Crear Tipo de Ritual",
	deactivate: "Desactivar",
	deleteConfirmation: "¿Desea realmente eliminar el tipo de ritual {name}?",
	details: {
		basicInfo: "Información Básica",
		noData: "Ningún dato disponible",
		timestamps: "Información del Sistema",
	},
	edit: "Editar Tipo de Ritual",
	empty: {
		description: "Registre los tipos de rituales practicados en el templo",
		title: "Ningún tipo de ritual encontrado",
	},
	filters: {
		status: {
			all: "Todos",
		},
	},
	form: {
		codeHint: "Se completa a partir del nombre — cámbialo solo si quieres otro",
		codeLabel: "Código",
		descriptionHint: "Descripción opcional del tipo de ritual",
		descriptionLabel: "Descripción",
		isActiveLabel: "Tipo activo en el sistema",
		nameHint: "Nombre que identifica el tipo de ritual",
		nameLabel: "Nombre del Tipo de Ritual",
		spiritualLineHint: "Línea espiritual predominante en este tipo de ritual",
		spiritualLineLabel: "Línea Espiritual Predominante",
	},
	loading: "Cargando detalles...",
	messages: {
		activated: "Tipo de ritual {name} activado con éxito",
		createError: "Error al crear tipo de ritual",
		created: "Tipo de ritual {name} creado con éxito",
		deactivated: "Tipo de ritual {name} desactivado con éxito",
		deactivatedWithDeps: "El tipo de ritual {name} tiene dependencias y fue desactivado",
		deleteError: "Error al eliminar tipo de ritual",
		deleted: "Tipo de ritual {name} eliminado con éxito",
		loadError: "Error al cargar tipos de rituales",
		toggleError: "Error al cambiar el estado del tipo de ritual",
		updateError: "Error al actualizar tipo de ritual",
		updated: "Tipo de ritual {name} actualizado con éxito",
	},
	noDescription: "Sin descripción",
	notFound: "Tipo de ritual no encontrado",
	searchPlaceholder: "Nombre, código o descripción...",
	spiritualLine: "Línea Espiritual",
	stats: {
		active: "Activos",
		total: "Tipos",
	},
	status: "Estado",
	table: {
		attendanceCards: "Fichas",
		headers: {
			createdAt: "Creado en",
			updatedAt: "Actualizado en",
		},
		name: "Nombre",
		spiritualLine: "Línea Espiritual",
		status: "Estado",
	},
	validation: {
		codeFormat: "El código solo debe contener letras minúsculas, números, guiones y guiones bajos",
		codeRequired: "El código es obligatorio",
		codeMaxLength: "El código debe tener máximo 50 caracteres",
		descriptionMaxLength: "La descripción debe tener máximo 500 caracteres",
		nameMaxLength: "El nombre debe tener máximo 100 caracteres",
		nameRequired: "El nombre es obligatorio",
		spiritualLineRequired: "La línea espiritual es obligatoria",
	},
};
